<template>
  <b-modal id="customer-show-pack" class="customer-show-pack" ref="modal" :title="dialog_title" hide-footer>

    <div class="row form-group">
      <div class="col-sm-8">
        <input type="text" class="form-control" v-model="name" id="name" placeholder="Indica el nombre del pack" />
        <label for="name" class="wabident-info">Nombre del Pack</label>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-sm-6">
        <v-select ref="psearch" class="wabident-selector" @search="searchProducts" :filterable="false" :options="products"
          placeholder="Busca el tratamiento/producto aquí ..." v-model="selected_product"></v-select>
        <label class="wabident-info">Elige un tratamiento aquí para añadirlo al pack</label>
      </div>

      <div class="col-sm-4">
        <select v-model="product_category_id" id="product_category_id" class="custom-select">
          <option :value="null">Todas</option>
          <option v-for="category, id in categories" :key="id" :value="category.id">{{ category.name }}</option>
        </select>
        <label for="product_category_id" class="wabident-info">Filtrar por unidad</label>
      </div>

      <transition name="fade">
        <div class="col-sm-2" v-if="selected_product">
          <button @click="addProduct" type="button" class="btn btn-wabident-round btn-block mt-2">
            <i class="fas fa-plus mr-2"></i> Añadir al Pack
          </button>
        </div>
      </transition>
    </div>

    <div class="row form-group">
      <div class="col">
        <table class="table treatments-table">
          <thead>
            <tr>
              <th v-if="is_core" colspan="1">ORDEN</th>
              <th colspan="7">TRATAMIENTO</th>
              <th colspan="1">P.UNIT</th>
              <th colspan="1">CANT.</th>
              <th colspan="1">BASE</th>
              <th colspan="1">DESC. (%)</th>
              <th v-if="clinic_type != 'dental'" colspan="1">DESC. (€)</th>
              <th colspan="1">TOTAL</th>
              <th colspan="1"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(line, index) in pack_lines" :key="index">
              <td v-if="is_core" class="pack-line-order " colspan="1" style="vertical-align: middle; text-align: center;">
                <div class="d-flex align-items-center justify-content-center">
                  <div class="pack-line-order__buttons">
                    <div v-if="index > 0" class="pack-line-order__btn pack-line-order__btn-up" @click="moveLineUp(index)">
                      <i class="fas fa-chevron-up"></i>
                    </div>
                    <div v-if="index < (pack_lines.length - 1)" class=" pack-line-order__btn pack-line-order__btn-down"
                      @click="moveLineDown(index)">
                      <i class="fas fa-chevron-down"></i>
                    </div>
                  </div>
                  <span class="pack-line-order__num">
                    {{ index + 1 }}
                  </span>

                </div>
              </td>
              <td colspan="7">{{ prettyLineName(line) }}</td>
              <td colspan="1">
                <input type="number" v-model.number="line.price" class="form-control wabident-xsmall" />
              </td>
              <td colspan="1">
                <input type="number" v-model.number="line.quantity" min="1" class="form-control wabident-xsmall" />
              </td>
              <td colspan="1">{{ prettyPrice(line) }}</td>
              <td colspan="1">
                <input type="number" v-model.number="line.discount" min="0" max="100"
                  class="form-control wabident-xsmall" />
              </td>
              <td v-if="clinic_type != 'dental'" colspan="1">
                <input type="number" v-model.number="line.abs_discount" min="0" class="form-control wabident-xsmall" />
              </td>
              <td colspan="1">{{ prettyNetPrice(line) }}</td>
              <td colspan="1" @click="removepackLine(index)" class="trash-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <path fill-rule="evenodd" d="M2 6a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1z"
                    clip-rule="evenodd" />
                  <path fill-rule="evenodd"
                    d="M10 3a1 1 0 0 0-1 1v1h6V4a1 1 0 0 0-1-1h-4zm7 2V4a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3v1H5a1 1 0 0 0-1 1v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V6a1 1 0 0 0-1-1h-2zM6 7v13a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7H6z"
                    clip-rule="evenodd" />
                  <path fill-rule="evenodd"
                    d="M10 10a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1zM14 10a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1z"
                    clip-rule="evenodd" />
                </svg>
              </td>
            </tr>
            <tr>
              <td :colspan="is_core ? 15 : 14">
              </td>
            </tr>
            <tr>
              <td :colspan="is_core ? 11 : 10">
              </td>
              <td colspan="2">
                {{ pretty_total }}
                <label class="total">BASE</label>
              </td>
              <td colspan="2">
                {{ pretty_net_total }}
                <label class="total">TOTAL</label>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row form-group">
      <div class="col buttons-column align-items-center">
        <button :disabled="is_loading" @click="onDelete" v-show="is_editing" class="btn btn-wabident-delete float-left"
          style="width: 53.6px; height: 53.6px"></button>
        <button @click="submitPack()" :disabled="is_loading" type="button"
          class="btn btn-primary btn-wabident float-left">
          Guardar Pack
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      name: null,
      pack: null,
      is_loading: false,
      pack_lines: [],
      searched_products: [],
      products: [],
      hierarchy: [],
      product_category_id: null,
      selected_product: null,
    };
  },
  watch: {
    product_category_id() {
      this.selected_product = null;
      this.products = [];
      this.searchProducts();
    }
  },
  computed: {
    quotation_disable_grouping() {
      return this.clinic && this.clinic.config.quotation_disable_grouping;
    },
    categories() {
      let ret = [];
      this.hierarchy.forEach((cat) => {
        this.addCategory(cat, ret, 0);
      });
      return ret;
    },
    filtered_pack_lines() {
      return this.pack_lines.map((line) => {
        return {
          price: line.price,
          product_id: line.product,
          quantity: line.quantity,
          discount: line.discount,
          abs_discount: line.abs_discount,
        }
      });
    },
    is_editing() {
      return this.pack;
    },
    clinic_type() {
      if (!this.clinic) return null;
      return this.clinic.type;
    },
    total() {
      return this.pack_lines.reduce((cur, val) => {
        return cur + Number(val.price) * Number(val.quantity);
      }, 0);
    },
    net_total() {
      return this.pack_lines.reduce((cur, val) => {
        return (
          cur +
          (Number(val.price) *
            Number(val.quantity) *
            (1 - Number(val.discount) / 100)) -
          val.abs_discount
        );
      }, 0);
    },
    pretty_net_total() {
      return WabiDent.fmtMoney(this.net_total);
    },
    pretty_total() {
      return WabiDent.fmtMoney(this.total);
    },
    dialog_title() {
      return this.is_editing ? "Editar Pack" : "Crear Pack";
    },
    ...mapGetters(["msgwindow", "errorwindow", "clinic", "is_core"]),
  },
  methods: {
    moveLineUp(index) {
      let tmp = this.pack_lines[index - 1];
      this.pack_lines[index - 1] = this.pack_lines[index];
      this.pack_lines[index] = tmp;
      this.$forceUpdate();
    },
    moveLineDown(index) {
      let tmp = this.pack_lines[index + 1];
      this.pack_lines[index + 1] = this.pack_lines[index];
      this.pack_lines[index] = tmp;
      this.$forceUpdate();
    },
    prettyLineName(line) {
      return line.name;
    },
    prettyTeeth(l) {
      return l.teeth.reduce((r, x) => {
        return r + " " + x;
      }, "");
    },
    prettyUnitPrice(line) {
      return WabiDent.fmtMoney(line.price);
    },
    prettyPrice(line) {
      return WabiDent.fmtMoney(line.price * line.quantity);
    },
    prettyNetPrice(line) {
      let price =
        Number(line.price) *
        Number(line.quantity) *
        (1 - Number(line.discount) / 100);

      price -= Number(line.abs_discount);
      return WabiDent.fmtMoney(price);
    },
    showNew() {
      this.product_category_id = null;
      this.selected_product = null;
      this.pack = null;
      this.name = null;
      this.pack_lines = [];

      this.loadCategories()
      this.$refs.modal.show();
    },
    showEdit(pack) {
      this.product_category_id = null;
      this.selected_product = null;
      this.pack = pack;
      this.name = pack.name;

      if (!pack.pack_lines || (pack.pack_lines.length == 0)) {
        this.pack_lines = [];
      } else {
        this.generatePackLines(pack.pack_lines);
      }

      this.loadCategories()
      this.$refs.modal.show();
    },
    removepackLine(index) {
      this.pack_lines.splice(index, 1);
    },
    addProduct() {
      if (!this.selected_product) {
        return;
      }
      this.addProductToPack(this.selected_product.value);
    },
    getLineForProductID(product_id) {
      let found = this.pack_lines.filter((line) => {
        return (line.product == product_id);
      });
      return found[0] || null;
    },
    addProductToPack(product, quantity = 1) {
      let line = this.getLineForProductID(product.id);
      if (line && !this.quotation_disable_grouping) {
        line.quantity += quantity;
      } else {
        this.pack_lines.push({
          product: product.id,
          name: product.name,
          quantity: quantity,
          price: product.price,
          discount: 0,
          abs_discount: 0,
          obj: product,
        });
      }
    },
    submitPack() {
      if (this.is_editing) {
        this.modifyPack();
      } else {
        this.savePack();
      }
    },
    onDelete() {
      if (!this.is_loading) {
        this.is_loading = true;
        axios.post(`/pack/${this.pack.id}/delete`, {
        }).then(() => {
          this.msgwindow.success('Pack eliminado con éxito');
          this.$refs.modal.hide();
          this.$emit('submit');
        }).catch(() => {
          this.msgwindow.error('Error eliminando Pack');
        }).then(() => {
          this.is_loading = false;
        });
      }
    },
    modifyPack() {
      if (!this.is_loading) {
        this.is_loading = true;
        axios.post(`/pack/${this.pack.id}/update`, {
          name: this.name,
          pack_lines: this.filtered_pack_lines,
        }).then(() => {
          this.msgwindow.success('Pack modificado con éxito');
          this.$refs.modal.hide();
          this.$emit('submit');
        }).catch(() => {
          this.msgwindow.error('Error modificando Pack');
        }).then(() => {
          this.is_loading = false;
        });
      }
    },
    savePack() {
      if (!this.is_loading) {
        this.is_loading = true;
        axios.post('/pack/create', {
          name: this.name,
          pack_lines: this.filtered_pack_lines,
        }).then(() => {
          this.msgwindow.success('Pack creado con éxito');
          this.$refs.modal.hide();
          this.$emit('submit');
        }).catch(() => {
          this.msgwindow.error('Error creando Pack');
        }).then(() => {
          this.is_loading = false;
        });
      }
    },
    fillSearchedProducts(data) {
      if(!data) {
        this.searched_products = [];
        this.products = [];
        return;
      }

      this.searched_products = data;

      let ps = this.searched_products.map((p) => {
        return {
          label: p.name,
          value: p,
        };
      });
 
      this.products = ps;
    },
    searchProducts(search, loading = null) {
      if (loading) {
        loading(true);
      }
      axios
        .get("/product", {
          params: {
            size: 100,
            search: search,
            product_category_id: this.product_category_id
          },
        })
        .then((response) => {
          if(loading){
            loading(false);
          }
          this.fillSearchedProducts(response.data.data);
        })
        .catch((error) => {
          console.log("[ERR] searchProducts:", error);
        })
        .then(() => {
          if (loading) {
            loading(false);
          }
        });
    },
    loadCategories() {
      axios
        .get("/product/hierarchy")
        .then((response) => {
          this.hierarchy = response.data;
        });
    },
    addCategory(cat, ret, level) {
      let prefix = '-'.repeat(level);

      ret.push({
        id: cat.id,
        slug: cat.slug,
        name: prefix + cat.name,
        parent_id: cat.parent_id,
        level: level
      });

      cat.children.forEach((subcat) => {
        this.addCategory(subcat, ret, level + 1);
      });
    },
    generatePackLines(pack_lines) {
      let product_ids = pack_lines.map((l) => {
        return l.product_id;
      });

      axios
        .get("/product", {
          params: {
            product_ids: product_ids,
          },
        })
        .then((response) => {
          let product_dict = {};

          response.data.forEach((p) => {
            product_dict[p.id] = p;
          });

          this.pack_lines = pack_lines.map((line) => {
            let product = product_dict[line.product_id];
            return {
              product: product.id,
              name: product.name,
              quantity: line.quantity,
              price: line.price ? line.price : product.price,
              discount: line.discount,
              abs_discount: line.abs_discount,
              obj: product,
            };
          });
        })
        .catch((error) => {
          console.log("[ERR] searchProducts:", error);
        });
    }
  },
  mounted() {
  },
};
</script>

<style lang="scss">
#customer-show-pack {
  .pack-line-order {
    &__num {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: bold;
      width: 25px;
      height: 25px;
      margin-left: 7.5px;
      border: 1px var(--theme-grey) solid;
      border-radius: 50%;
    }

    &__buttons {
      font-size: 12px;
    }

    &__btn {
      color: var(--theme-color);
      transition: .3s;
      cursor: pointer;
    }
  }

  .modal-dialog {
    max-width: 65%;
  }

  .treatments-table {
    thead {
      th {
        border-top: none;
        border-bottom: 1px var(--theme-grey) solid;
        color: var(--theme-grey);
        font-size: 11px;
        letter-spacing: 0.16px;
        font-weight: 300;
        line-height: 1.82;
      }
    }

    tbody {
      td {
        font-size: 16px;
        color: var(--theme-text-color);
        border: none;
        vertical-align: middle;

        input {
          margin: 0;
          width: 80px;
        }

        .total {
          display: block;
          font-size: 11px;
          line-height: 1.82;
          font-weight: 300;
          color: var(--theme-grey);
          letter-spacing: 0.16px;
          margin-top: 9px;
          border-top: 1px var(--theme-grey) solid;
          width: 100%;
          padding: 7px;
        }
      }

      .trash-icon {
        cursor: pointer;
        color: var(--theme-grey);
        transition: all 0.2s;

        &:hover {
          color: var(--theme-color-absent);
        }

        svg {
          fill: currentColor;
        }
      }
    }
  }

  .customer-info {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: var(--theme-grey-bg);
    border-bottom: 1px var(--theme-line-color) solid;
    padding: 15px;

    .customer-photo {
      width: 62px;
      height: 62px;
      background-size: cover;
      background-position: center center;
      border-radius: 31px;
      margin-left: 4px;
    }

    .customer-data {
      padding: 11px 18px;
      font-size: 20px;
      line-height: 1.25;
      color: var(--theme-text-color);
    }
  }

  .buttons-column {
    button {
      flex: 1 0 180px;
    }

    button+button {
      margin-left: 10px;
    }

    .btn-link+.btn-link {
      margin-left: 10px;
    }

    .btn-sendmail,
    .btn-print {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 13px;
      height: 100%;
      cursor: pointer;
      display: block;
      width: 24px;
      color: var(--theme-grey) !important;
      transition: all 0.2s;
      fill: currentColor;

      &:hover {
        color: var(--theme-color) !important;
      }

      svg {
        transition: all 0.2s;
        fill: currentColor;
      }
    }
  }
}
</style>

